/* eslint-disable indent */
import { Dispatch } from 'redux';
import { createActions, createAction } from 'redux-actions';
import _reduce from 'lodash/reduce';
import _isEmpty from 'lodash/isEmpty';

import {
    GET_TAG,
    SET_TAG,
    UPDATE_TAG,
    GET_SINGLE_USE_TAGS,
    SET_INVALID_TAGS,
    CLEAR_ERRORS,
} from '../constants/actionTypes/personalization';
import { IPersonalizationGetTagParams, IPersonalizationSetTagParams } from '../types/personalization';
import configs from '../constants/configs';
import { request } from '../common/request';

export const [
    {
        // @ts-ignore createActions nests the return if the type constant has a slash but the types don't expect that
        personalizationTypes: { getTagBegin, getTagSuccess, getTagError },
    },
    {
        // @ts-ignore createActions nests the return if the type constant has a slash but the types don't expect that
        personalizationTypes: { setTagBegin, setTagSuccess, setTagError },
    },
    {
        // @ts-ignore createActions nests the return if the type constant has a slash but the types don't expect that
        personalizationTypes: { getSingleUseTagsBegin, getSingleUseTagsSuccess, getSingleUseTagsError },
    },
] = [GET_TAG, SET_TAG, GET_SINGLE_USE_TAGS].map((types) =>
    createActions({
        [types.BEGIN]: (payload) => payload,
        [types.SUCCESS]: (payload) => payload,
        [types.ERROR]: (payload) => payload,
    })
);

export const updateTag = createAction(UPDATE_TAG);
export const setInvalidTags = createAction(SET_INVALID_TAGS);
export const clearErrors = createAction(CLEAR_ERRORS);

export const getTag = (queryParams: IPersonalizationGetTagParams) => async (dispatch: Dispatch) => {
    dispatch(getTagBegin());
    try {
        const data = await request.get(
            `${configs.personalizationTag}${
                !_isEmpty(queryParams)
                    ? _reduce(queryParams, (acc, val, key) => `${acc}${acc !== '?' ? '&' : ''}${key}=${val}`, '?')
                    : ''
            }`
        );

        dispatch(getTagSuccess(data));
    } catch (error) {
        dispatch(getTagError({ error: error.message }));
    }
};

export const setTag = (payload: IPersonalizationSetTagParams) => async (dispatch: Dispatch<any>) => {
    dispatch(setTagBegin());
    try {
        await request.post(configs.personalizationTag, payload);

        dispatch(setTagSuccess());
        dispatch(updateTag(payload));
    } catch (error) {
        dispatch(setTagError({ error: error.message }));
    }
};
